<template>
  <div id="info">
    <van-nav-bar
      title="身份信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      style="margin-bottom: 20px;"
    />
    <van-form>
      <van-field
        v-model="postForm.name"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="postForm.id_card"
        name="身份证号码"
        label="身份证号码"
        placeholder="身份证号码"
        :rules="[{ required: true, message: '请填写身份证号码' }]"
      />
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <div class="uploader">
              <van-field name="uploader" title="">
                <template #input>
                  <van-uploader v-model="postForm.id_card_front_img"
                                :max-size="maxSize"
                                :before-read="beforeRead"
                                :after-read="file => onRead(file, 'id_card_front')"
                                :before-delete="file => deleteFile(file, 'id_card_front')"
                                :max-count="1"
                                @oversize="onOversize"/>
                </template>
              </van-field>
            </div>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.id_card_back_img"
                              :max-size="maxSize"
                              :before-read="beforeRead"
                              :after-read="file => onRead(file, 'id_card_back')"
                              :before-delete="file => deleteFile(file, 'id_card_back')"
                              :max-count="1"
                              @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <van-field
        v-model="postForm.bank_card_no"
        name="银行卡号"
        label="银行卡号"
        placeholder="银行卡号"
      />
      <van-field
        v-model="postForm.deposit_name"
        name="开户行名称"
        label="开户行名称"
        placeholder="开户行名称"
      />
      <van-field
        v-model="postForm.bank"
        name="银行名称"
        label="银行名称"
        placeholder="银行名称"
      />
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">卡号正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.bank_front_img"
                              :max-size="maxSize"
                              :before-read="beforeRead"
                              :after-read="file => onRead(file, 'bank_front')"
                              :before-delete="file => deleteFile(file, 'bank_front')"
                              :max-count="1"
                              @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">卡号反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.bank_back_img"
                              :max-size="maxSize"
                              :before-read="beforeRead"
                              :after-read="file => onRead(file, 'bank_back')"
                              :before-delete="file => deleteFile(file, 'bank_back')"
                              :max-count="1"
                              @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {getManInfo, updateManInfo} from '@/api/user'
import Uploader from './uploader'
import {getOssToken} from "../../../api/order";
import OSS from "ali-oss";
import {getFileRealPath} from "../../../api/util";
import {updateWorkerName} from "../../../api/user";

export default {
  name: 'info',
  components: {
    Uploader
  },
  data () {
    return {
      maxSize: 40960 * 1024,
      postForm: {
        name: '',
        id_card: '',
        id_card_front_img: [],
        id_card_back_img: [],
        img_id_card_front: '',
        img_id_card_back: '',
        img_bank_card_front: '',
        img_bank_card_back: '',
        bank_front_img: [],
        bank_back_img: [],
        bank: '',
        deposit_name: '',
        bank_card_no: '',
      },
      imageList: [],
      activeNames: ['1'],
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    async initUserInfo() {
      await getManInfo().then((res) => {
        if (res.data.data) {
          this.postForm.name = res.data.data && res.data.data.worker_name
          const details = res.data.data && res.data.data.certificate_list
          if (details.id_card) {
            this.postForm.id_card = details.id_card.id_card_no
            this.postForm.id_certificate_id = details.id_card.certificate_id
            this.postForm.id_card_front_img = [{
              url: details.id_card.img_id_card_front.file_url_thumb,
              status: ''
            }]
            this.postForm.id_card_back_img = [
              {
                url: details.id_card.img_id_card_back.file_url_thumb,
                status: ''
              }
            ]
            this.postForm.img_id_card_front = details.id_card.img_id_card_front.file_id
            this.postForm.img_id_card_back = details.id_card.img_id_card_back.file_id
            this.$forceUpdate()
          }
          if (details.bank_info) {
            this.postForm.bank_card_no = details.bank_info.bank_card_no
            this.postForm.bank = details.bank_info.bank_name
            this.postForm.deposit_name = details.bank_info.depositary_bank
            this.postForm.bank_certificate_id = details.bank_info.certificate_id
            this.postForm.bank_front_img = [{
              url: details.bank_info.img_bank_card_front.file_url_thumb,
              status: ''
            }]
            this.postForm.bank_back_img = [
              {
                url: details.bank_info.img_bank_card_back.file_url_thumb,
                status: ''
              }
            ]
            this.postForm.img_bank_card_front = details.bank_info.img_bank_card_front.file_id
            this.postForm.img_bank_card_back = details.bank_info.img_bank_card_back.file_id
          }

          console.log('postForm......', this.postForm)
          this.$forceUpdate()
        }
      })
    },
    onOversize() {

    },
    onClickLeft() {
      this.$router.push('/my')
    },
    beforeRead(file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile(file, index) {
      if (index === 'id_card_front') {
        this.postForm.img_id_card_front = ''
        this.postForm.id_card_front_img = []
      }
      if (index === 'id_card_back') {
        this.postForm.img_id_card_back = ''
        this.postForm.id_card_back_img = []
      }
      if (index === 'bank_front') {
        this.postForm.img_bank_card_front = ''
        this.postForm.bank_front_img = []
      }
      if (index === 'bank_back') {
        this.postForm.img_bank_card_back = ''
        this.postForm.bank_back_img = []
      }
      this.$forceUpdate()
    },
    onRead(file, index) {
      this.uploadImg(file.file, index)
    },
    async uploadImg(file, index) {
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      console.log('fjklsdfkljsflsl')
      await getOssToken({file_suffix: fileSuffix}).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileRealPath({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  if (index === 'id_card_front') {
                    this.postForm.img_id_card_front = ossData.file_id
                    this.postForm.id_card_front_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }
                  if (index === 'id_card_back') {
                    this.postForm.img_id_card_back = ossData.file_id
                    this.postForm.id_card_back_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }
                  if (index === 'bank_front') {
                    this.postForm.img_bank_card_front = ossData.file_id
                    this.postForm.bank_front_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }
                  if (index === 'bank_back') {
                    this.postForm.img_bank_card_back = ossData.file_id
                    this.postForm.bank_back_img = [{
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }]
                  }

                  console.log('jflskadfjklasflkdsalfds', this.postForm)
                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
    forwardLogin() {
      this.$router.push({path: '/'})
    },
    async onSubmit() {
      if (this.postForm.name === '' || typeof this.postForm.name === 'undefined') {
        Toast('姓名不能为空');
        return false;
      }
      updateWorkerName({name: this.postForm.name}).then((res) => {
        console.log('res.........', res)
      })

      if (this.postForm.id_card === '' || typeof this.postForm.id_card === 'undefined') {
        Toast('身份证号码不能为空');
        return false;
      }

      const idCardInfo = {
        certificate_type: 'id_card',
        info:
          {
            id_card_no: this.postForm.id_card,
            img_id_card_front: this.postForm.img_id_card_front,
            img_id_card_back: this.postForm.img_id_card_back
          }
      }
      if (this.postForm.id_certificate_id) {
        idCardInfo.certificate_id = this.postForm.id_certificate_id
      }

      if (idCardInfo.info && idCardInfo.info.img_id_card_front) {
        const updateIdCardResult = await updateManInfo(idCardInfo)
        if (updateIdCardResult.data.code !== 0) {
          Toast('提交失败')
          return false
        }
      }

      const bankInfo = {
        certificate_type: 'bank_info',
        info:
          {
            bank_card_no: this.postForm.bank_card_no,
            bank_name: this.postForm.bank,
            depositary_bank: this.postForm.deposit_name,
            img_bank_card_front: this.postForm.img_bank_card_front,
            img_bank_card_back: this.postForm.img_bank_card_back
          }
      }

      if (this.postForm.bank_certificate_id) {
        bankInfo.certificate_id = this.postForm.bank_certificate_id
      }

      if (bankInfo.info && bankInfo.info.img_bank_card_front) {
        const updateBankResult = await updateManInfo(bankInfo)
        if (updateBankResult.data.code !== 0) {
          Toast('提交失败')
          return false
        }
      }
      Toast("提交成功");
      this.$router.push('/my')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/components/identity.vue